import * as React from 'react';
import { CodeBlock } from '../../cookbook-ui/custom-components/CodeBlock/CodeBlock';
import { KitchenThemeContext } from '../../App';
import { convertArrayToTabBar } from './utils/tabBarFn';
import { AlertInlineMain, TabBar } from '@inmoment/the-kitchen';

export interface Props {}

const enumString = `enum DefaultPreselectedCalendarListIds {
  TODAY = '_today',
  YESTERDAY = '_yesterday',
  LAST_7_DAYS = '_last7Days',
  LAST_30_DAYS = '_last30Days',
  THIS_WEEK = '_thisWeek',
  LAST_WEEK = '_lastWeek',
  LAST_4_WEEKS = '_last4Weeks',
  THIS_MONTH = '_thisMonth',
  LAST_MONTH = '_lastMonth',
  LAST_3_MONTHS = '_last3Months',
  THIS_QUARTER = '_thisQuarter',
  LAST_QUARTER = '_lastQuarter',
  THIS_YEAR = '_thisYear',
  LAST_YEAR = '_lastYear'
}
`;

const optionString = `const defaultPreselectedCalendarListOptions: PreselectedCalendarListOptions[] = [
  {
    title: 'Today',
    first: new Date(currDate),
    last: new Date(currDate),
    id: DefaultPreselectedCalendarListIds.TODAY
  },
  {
    title: 'Yesterday',
    first: new Date(yesterday),
    last: new Date(yesterday),
    id: DefaultPreselectedCalendarListIds.YESTERDAY
  },
  {
    title: 'Last 7 Days',
    first: new Date(lastSeven),
    last: new Date(currDate),
    id: DefaultPreselectedCalendarListIds.LAST_7_DAYS
  },
  {
    title: 'Last 30 Days',
    first: new Date(last30),
    last: new Date(currDate),
    id: DefaultPreselectedCalendarListIds.LAST_30_DAYS
  },
  {
    title: 'This Week',
    first: new Date(thisWeekStart),
    last: new Date(thisWeekEnd),
    id: DefaultPreselectedCalendarListIds.THIS_WEEK
  },
  {
    title: 'Last Week',
    first: new Date(lastWeekStart),
    last: new Date(lastWeekEnd),
    id: DefaultPreselectedCalendarListIds.LAST_WEEK
  },
  {
    title: 'Last 4 Weeks',
    first: new Date(fourWeeksStart),
    last: new Date(lastWeekEnd),
    id: DefaultPreselectedCalendarListIds.LAST_4_WEEKS
  },
  {
    title: 'This Month',
    first: new Date(thisMonthStart),
    last: new Date(thisMonthEnd),
    id: DefaultPreselectedCalendarListIds.THIS_MONTH
  },
  {
    title: 'Last Month',
    first: new Date(lastMonthStart),
    last: new Date(lastMonthEnd),
    id: DefaultPreselectedCalendarListIds.LAST_MONTH
  },
  {
    title: 'Last 3 Months',
    first: new Date(threeMonthStart),
    last: new Date(lastMonthEnd),
    id: DefaultPreselectedCalendarListIds.LAST_3_MONTHS
  },
  {
    title: 'This Quarter',
    first: new Date(thisQuarterStart),
    last: new Date(thisQuarterEnd),
    id: DefaultPreselectedCalendarListIds.THIS_QUARTER
  },
  {
    title: 'Last Quarter',
    first: new Date(lastQuarterStart),
    last: new Date(lastQuarterEnd),
    id: DefaultPreselectedCalendarListIds.LAST_QUARTER
  },
  {
    title: 'This Year',
    first: new Date(currDate.getFullYear(), 0, 1),
    last: new Date(currDate.getFullYear(), 11, 31),
    id: DefaultPreselectedCalendarListIds.THIS_YEAR
  },
  {
    title: 'Last Year',
    first: new Date(lastYear.getFullYear(), 0, 1),
    last: new Date(lastYear.getFullYear(), 11, 31),
    id: DefaultPreselectedCalendarListIds.LAST_YEAR
  }
];`;

export const data1 = ['DefaultIds', 'DefaultCalenderOptions'].map(convertArrayToTabBar);

export const CalendarDocumentation: React.FC<Props> = (props) => {
  const [tab, setTab] = React.useState('DefaultIds');
  const { theme } = React.useContext(KitchenThemeContext);

  return (
    <div>
      <br />
      <br />
      <AlertInlineMain color="success" title="Exports" subtitle="The below enum & array are both available for import from the-kitchen library." />
      <br />
      <br />
      <AlertInlineMain
        color="warning"
        title="Note:"
        subtitle="At this time, the calendar picker only outputs dates. The time in the date object is not to be relied on for consistency and should be supplemented with the clients preferred implementation. Use `date.setUTCHours(0, 0, 0, 0)` or `date.setHours(0, 0, 0, 0)` to normalize the time outputs if needed."
      />
      <br />
      <br />
      <div style={{ height: 46 }}>
        <TabBar stretch data={data1} color={theme} onTabChange={({ tab }) => setTab(tab!.title)} />
      </div>
      {tab === 'DefaultIds' && <CodeBlock hasTopRadius={false} code={enumString} />}
      {tab === 'DefaultCalenderOptions' && <CodeBlock hasTopRadius={false} code={optionString} />}
      <br />
      <br />
    </div>
  );
};
